import { render, staticRenderFns } from "./CadastroOrganizacao.vue?vue&type=template&id=0a97b7d7"
import script from "./CadastroOrganizacao.vue?vue&type=script&lang=js"
export * from "./CadastroOrganizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports